// extracted by mini-css-extract-plugin
export var border = "_1m-7";
export var brand = "_1m-r";
export var button = "_1m-j";
export var center = "_1m-9";
export var centered = "_1m-5";
export var closeButton = "_1m-b";
export var disabledWrapper = "_1m-k";
export var error = "_1m-n";
export var extraLarge = "_1m-4";
export var extraSmall = "_1m-1";
export var fill = "_1m-g";
export var footer = "_1m-f";
export var footerAction = "_1m-h";
export var footerButtons = "_1m-i";
export var header = "_1m-6";
export var icon = "_1m-m";
export var info = "_1m-q";
export var inline = "_1m-8";
export var large = "_1m-3";
export var main = "_1m-c";
export var modal = "_1m-0";
export var neutral = "_1m-s";
export var noPadding = "_1m-e";
export var none = "_1m-t";
export var scrollable = "_1m-d";
export var small = "_1m-2";
export var success = "_1m-p";
export var tight = "_1m-l";
export var titleIcon = "_1m-a";
export var warn = "_1m-o";